let taskStatusTypes = {
    translated: false,
    data: [
        {
            value: 0,
            color: 'grey',
            name: 'mdi-wrench-outline',
            tooltip: 'todo'
        },
        {
            value: 1,
            color: 'orange',
            name: 'mdi-progress-check',
            tooltip: 'inprogress'
        },
        {
            value: 2,
            color: 'green',
            name: 'mdi-check',
            tooltip: 'done'
        }
    ],
    updateLanguage: function(languageData) {
        if(!this.translated) {
            this.data.forEach(element => {
                element.tooltip = languageData.tasks[element.tooltip];
            });
        this.translated = true;
        }
    }
}

export default taskStatusTypes;